import * as React from 'react';
import { AdminDashboardPageLayout } from '../../containers/AdminDashboardPageLayout';
import { ReportsContainer } from '../../containers/reports/ReportsContainer';

export const AdminReportsPage: React.FC = () => {
	return (
		<AdminDashboardPageLayout>
			<ReportsContainer />
		</AdminDashboardPageLayout>
	);
};
